import { useState } from 'react';
import ProfileRow from '../../components/ProfileRow';
import ProfileFull from '../../Pages/Profile/ProfileFull';
import useProfileData from '../../hooks/useProfileData';

/**
 * EventContact - Component for managing event contacts
 * Shows search bar when no contact, ProfileFull when contact exists
 * Has profile row header with remove button (similar to chat profile view)
 */
export default function ContactPanel({ contactId, eventId, predictionData, onRemoveContact, onAddContact }) {
  const { profile } = useProfileData(contactId);

  if (!contactId) {
    // Show search bar when no contact
    return (
      <div className="flex flex-col h-full">
        <div className="p-5">
          <p className="mb-3 text-sm font-semibold text-primary">Add Contact</p>
          <div className="relative">
            <input
              type="text"
              placeholder="Search users..."
              className="w-full rounded-lg border border-input bg-background px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-ring"
              disabled
            />
            {/* TODO: When user selects a contact from search, call onAddContact(contactId) */}
          </div>
        </div>
      </div>
    );
  }

  // Show ProfileFull with profile row header when contact exists
  return (
    <div className="flex flex-col h-full">
      {/* Header with profile and remove button - only show remove if event exists */}
      <div className="shrink-0 px-5 py-2 flex items-center justify-between border-b border-border">
        <ProfileRow 
          profile={profile} 
          size="md" 
          subtitle={predictionData ? (predictionData.ovulationActual ? 'Ovulation confirmed' : 'Ovulation predicted') : undefined}
        />
        {eventId && eventId !== 'new' && (
          <button
            onClick={onRemoveContact}
            className="ml-3 px-3 py-1.5 text-xs font-medium text-destructive border border-destructive/10 hover:bg-destructive/10 rounded-md transition-colors"
          >
            Remove Contact
          </button>
        )}
      </div>

      {/* ProfileFull content */}
      <div className="flex-1 min-h-0">
        <ProfileFull id={contactId} initialTab="calendar" />
      </div>
    </div>
  );
}
